// extracted by mini-css-extract-plugin
module.exports = {"menu":"e2u8T","block":"LOlaz","block__desktop":"SPGYf","block__left":"FUeNO","buttonInclusive":"KhAgO"};